import { __decorate } from "tslib";
import { css, html, observable, repeat } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { setValueWithAccessor } from './utils';
/**
 * The AG Select Renderer element.
 * @public
 * @tagname %%prefix%%-select-renderer
 */
export class SelectRenderer extends FoundationElement {
    constructor() {
        super(...arguments);
        this.selectionChanged = (e) => {
            this.value = e.target.value;
            this.params.onSelect(e.target.value, this.params);
        };
    }
    init(params) {
        var _a;
        if (!params)
            return;
        this.params = params;
        this.value = setValueWithAccessor((_a = params.node) === null || _a === void 0 ? void 0 : _a.data, params.accessor) || undefined;
    }
    getGui() {
        return this;
    }
    destroy() { }
    refresh(params) {
        return true;
    }
}
__decorate([
    observable
], SelectRenderer.prototype, "params", void 0);
__decorate([
    observable
], SelectRenderer.prototype, "value", void 0);
/**
 * The AG Select Renderer Styles.
 * @public
 */
export const agSelectRendererStyles = css `
  :host,
  .select-renderer,
  zero-option,
  ::part(listbox),
  ::part(control) {
    max-width: var(--select-renderer-max-width);
    min-width: 100%;
  }
`;
/**
 * Get a Design System prefixed Select template.
 * @param designSystem - The design system prefix to use. Defaults to 'foundation'.
 * @returns A Select component template prefixed with the correct design system.
 * @public
 */
export const getSelectRendererTemplate = (designSystem = 'foundation') => {
    const selectComponent = `${designSystem}-select`;
    const optionComponent = `${designSystem}-option`;
    return html `
    <${selectComponent}
      class="select-renderer"
      @change=${(x, c) => x.selectionChanged(c.event)}
      :value=${(x) => x.value}
    >
      <${optionComponent}
        defaultSelected
        style="display: none;"
      >
        ${(x) => x.params.defaultValue || 'Select option'}
      </${optionComponent}>
      ${repeat((x) => x.params.options(x.params.node.data), html `
        <${optionComponent} value=${(x) => x.name}>${(x) => x.displayName}</${optionComponent}>
      `)}
    </${selectComponent}>
  `;
};
/**
 * A function that returns a Foundation Select Renderer registration for configuring the component with a DesignSystem.
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-select-renderer\>
 */
export const foundationAgSelectRenderer = SelectRenderer.compose({
    baseName: 'select-renderer',
    styles: agSelectRendererStyles,
    template: getSelectRendererTemplate(),
});
